interface response {
  code: number;
  message: string;
  data: Array<string>;
}

export function broadcast (): Promise<response> {
  return request({
    url: '/gamecard/v2/share/assistance/broadcast'
  });
}
